import React from 'react';

const DropLoaderLarge = () => {
  return <div className="drop-loader large"></div>;
};

export default DropLoaderLarge;
